App.OrderContentEditComponent = Em.Component.extend
  classNames: [ 'order-content-edit' ]

  session: Em.inject.service('session')

  # ---
  # props
  # ---
  organization: null
  order: null

  # ---
  # Текущее состояние:
  # index, dish-select, dish-configurator
  # ---
  currentAction: 'dish-configurator'

  isActionIndex:            Em.computed.equal('currentAction', 'index')
  isActionDishSelect:       Em.computed.equal('currentAction', 'dish-select')
  isActionDishConfigurator: Em.computed.equal('currentAction', 'dish-configurator')
  # ---
  # Внутренний стейт, который шарится между экранами
  # ---
  selectedBuddy: null
  selectedDish:  null
  selectedItem:  null

  showButtonForOptionalModifiers: localStorage.getItem('showButtonForOptionalModifiers') == 'true'

  showCutlery: (->
    @get('order.organization.features.max_cutlery')
  ).property('order.organization.features.max_cutlery')

  actions:
    # ---
    # Поменять конфигурацию элемента
    # ---
    editItemConfig: (item) ->
      @set('selectedItem', item)
      @set('selectedDish', null)
      @set('currentAction', 'dish-configurator')
      false

    # ---
    # Перейти в экран выбора блюд
    # ---
    startDishSelect: (buddy) ->
      @set('selectedBuddy', buddy)
      @set('currentAction', 'dish-select')
      false

    # ---
    # Блюдо выбрано
    # ---
    dishSelected: (dish, showConfigForOptionalModifiers) ->
      showConfig = if @get('showButtonForOptionalModifiers') then !Em.isEmpty(dish.get('options')) && !dish.get('hasOptionalModifiers') else !Em.isEmpty(dish.get('options'))
      if showConfig || showConfigForOptionalModifiers
        @set('selectedDish', dish)
        @set('currentAction', 'dish-configurator')
      else
        @send('addItemToBuddy',
          @get('selectedBuddy'), dish)

      false

    # ---
    # Перейти обратно из списка блюд
    # ---
    cancelDishSelect: ->
      @set('selectedBuddy', null)
      @set('currentAction', 'index')
      false

    # ---
    # Добавить нового парня в заказ
    # ---
    addBuddy: ->
      order = @get('order')

      buddy = @store.createRecord 'order_buddy',
        # todo i18n
        name: 'Участник заказа'
        order: order

      buddy.save()
      .then =>
        @sendAction('onContentChanged')
      false

    buddyContentChanged: ->
      @sendAction('onContentChanged')
      false

    # ---
    # Добавить парню блюдо с конфигурацией
    # ---
    addItemToBuddy: (buddy, dish, config=null, comment=null) ->
      dish.set('loading', true)
      order = @get('order')

      buddy.get('items').then (items) =>
        # Ищем элемент с такой конфигурацией
        item = items.find (item) ->
          dishesAreSame  = item.get('dish.id') is dish.get('id')
          commentsAreSame  = item.get('comment') is comment
          itemConfig = _.map(item.get('config'), (c) ->
            id: c.id
            name: c.name
            value: _.map(c.value, (v) ->
              id: v.id
              name: v.name
              price: v.price
              amount: v.amount
            )
          )
          configsAreSame = _.isEqual(itemConfig, config) || _.isEqual(item.get('config'), config)
          dishesAreSame and configsAreSame and commentsAreSame
        unless item
          @send('createItem', {
            name:    dish.get('name')
            price:   dish.get('price')
            dish:    dish
            amount:  if dish.get('metric') then dish.get('min_qty') else 1
            order:   order
            buddy:   buddy
            config:  config
            comment: comment}, dish)
        else
          item.incrementProperty('amount', 1)
          item.save()
          .then =>
            @sendAction('onContentChanged')
            Em.run.later =>
              dish.set('loading', false)
        
    createItem: (payload, dish) ->
      store = @get('store')
      item = store.createRecord('order_item', payload)
      item.save()
      .then =>
        @sendAction('onContentChanged')
        Em.run.later =>
          dish.set('loading', false)
      false

    # ---
    # Конфигурация блюда была принята
    # ---
    acceptConfiguration: (dish, config, comment=null) ->
      if @get('selectedItem')
        item = @get('selectedItem')
        item.set('comment', comment)
        item.set('config',  config)
        item.save().then =>
          @sendAction('onContentChanged')
        @set('currentAction', 'index')
      else
        buddy = @get('selectedBuddy')
        @send('addItemToBuddy', buddy, dish, config, comment)
        @set('currentAction', 'index')


      @set('selectedDish',  null)
      @set('selectedItem',  null)
      false

    # ---
    # Вернуться из конфигуратора в список выбора блюд
    # ---
    cancelConfigurator: ->
      if @get('selectedItem')
        @set('currentAction', 'index')
      else
        @set('currentAction', 'dish-select')

      @set('selectedDish',  null)
      @set('selectedItem',  null)
      false

    selectDish: ->
      @sendAction('onContentChanged')